module.exports = __webpack_public_path__ + "static/media/guarda.7d2cdcb8.png";